import { FC } from 'react';
import cn from 'classnames';
import { match } from 'ts-pattern';

import { ButtonTemplate } from '@catawiki/cata-style';

import style from './Control.module.scss';

interface Props {
  autoPlay?: boolean;
  isPlaying: boolean;
  toggleVideo: () => void;
}

const getControlImage = (autoPlay: boolean, isPlaying: boolean) =>
  match({ autoPlay, isPlaying })
    .with({ autoPlay: true, isPlaying: true }, () => 'video-pause-autoplay')
    .with({ autoPlay: true, isPlaying: false }, () => 'video-play-autoplay')
    .with({ autoPlay: false, isPlaying: true }, () => 'video-pause')
    .with({ autoPlay: false, isPlaying: false }, () => 'video-play')
    .exhaustive();

export const Control: FC<Props> = ({
  autoPlay = false,
  isPlaying,
  toggleVideo,
}) => (
  <ButtonTemplate
    className={cn(style.overlay, {
      [style.playing]: isPlaying,
    })}
    onClick={toggleVideo}
  >
    <img
      alt={isPlaying ? 'Pause video' : 'Play video'}
      className={cn({
        [style.autoplay]: autoPlay,
        [style.play]: !isPlaying,
        [style.pause]: isPlaying,
      })}
      src={`/assets/pages/images/controls/${getControlImage(
        autoPlay,
        isPlaying
      )}.svg`}
    />
  </ButtonTemplate>
);
